// src/models/Insights/versionDistribution.ts
//
// Pure, presentation-agnostic helpers for turning `VersionBucket[]` into per-group totals.
// The ranked-top-N-versions-plus-"Other" bucketing this file used to hold
// (`buildVersionChartData`/`flattenVersionTotals`/`OTHER_BUCKET_LABEL`) was specific to the
// retired ranked-list firmware chart (`VersionDistributionChart`, replaced by
// `FirmwareVersionCurrency` + `computeFirmwareCurrency`) and was removed once nothing
// rendered a ranked list anymore. `sumCountsByGroup` survives because `MobileVersionCurrency`
// still needs one group's total independent of any per-version breakdown.

import type { VersionBucket } from '@/models/Insights/InsightsTypes';

/** Total device count per `group` value across all buckets - feeds the mobile platform summary
 * line (iOS/Android totals) and the excluded-group footnote count, both of which need one
 * group's total independent of any per-version breakdown. */
export function sumCountsByGroup(buckets: VersionBucket[]): Map<string, number> {
  const totals = new Map<string, number>();
  for (const bucket of buckets) {
    totals.set(bucket.group, (totals.get(bucket.group) ?? 0) + bucket.count);
  }
  return totals;
}
